import React, { useState, useEffect, useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import LocalStorage from "../../../LocalStorage";
import LoginSignUpModal from "../Login/loginSignUpModal";
import {
  WebContext,
  thumborImageUrl,
  isEmptyObject,
  getDomainValue,
  getTripkartTemplates,
} from "../../../Utility";
import { MobileNavDrawer } from "./mobileNavbar";
import compnentsMap from "./components";
import { withBackground } from "../../../utils/withBackground";
import logout from '../../../assets/images/logout.png';
const TripkartTemplates = getTripkartTemplates();

const SERVICES_ADDITIONAL_PAGE_DATA = [
  { slug_url: "services", is_show: true },
  { slug_url: "terms-and-conditions", is_show: true },
];

export default ({ nonTransparentNav = false }) => {
  let websiteData = useContext(WebContext);
  let { themeData = {}, articles = [] } = websiteData;
  const {
    template_name = "template1",
  } = themeData;
  const {
    memberProfile = {},
    username = null,
    navbarTemplateType = "NAVBAR_1",
    isV2Template = false,
    isLoggedIn,
  } = websiteData || {};
  const { website_modules: websiteModules } = memberProfile || {};
  const {
    flight: isFlightEnabled = false,
    hotel: isHotelEnabled = false,
    packages_api: isPackageApiEnabled = false,
    news: isNewsEnabled = false,
    packages: isPackagesEnabled = true,
    pay_safely: isPaySafelyEnabled = true,
    remit_allowed: isRemitEnabled = true,
    video_tours: isVideoToursEnabled = true,
  } = websiteModules || {};
  let { logo_url = null } = memberProfile;
  const domainName = getDomainValue();

  const knowUsItemInitialState = [
    {
      label: "About Us",
      link: `/${username ? `${username}/` : ""}about`,
      reloadLink: true,
    },
    { label: "Contact Us", link: `/${username ? `${username}/` : ""}contact` },
  ];
  const [knowUsItem, setKnowUsItem] = useState(knowUsItemInitialState);

  const addToKnowUsItem = (arr = []) => {
    let knowUsItemTemp = [...knowUsItem];
    arr.forEach((item) => {
      if (item.slug_url && item.is_show) {
        let tempLabel = item.slug_url.replace(/_|-/g, " ");
        tempLabel = tempLabel.charAt(0).toUpperCase() + tempLabel.slice(1);
        const tempObj = {
          label: tempLabel,
          link: {
            pathname: `/${username ? `${username}/` : ""}pages/${
              item.slug_url
            }`,
            state: {
              title: item.title,
              text: item.text,
              image_url: item.image_url,
              is_advance: item.is_advance,
              text_advance: item.text_advance,
            },
          },
        };
        knowUsItemTemp.push(tempObj);
      }
    });
    setKnowUsItem(knowUsItemTemp);
  };

  let contentArrInitial = [
    {
      label: "Flights",
      link: `/${username ? `${username}/` : ""}flights`,
      isShow: isFlightEnabled,
    },
    {
      label: "Hotels",
      link: `/${username ? `${username}/` : ""}hotelsearch/`,
      isShow: isHotelEnabled,
    },
    {
      label: "Packages",
      link: `/${username ? `${username}/` : ""}package/`,
      isShow: isPackageApiEnabled,
      fetchFromServer: true,
    },
    {
      label: "Packages",
      link: `/${username ? `${username}/` : ""}packages/`,
      isShow: !isPackageApiEnabled,
    },
    {
      label: "Remit",
      link: `/${username ? `${username}/` : ""}remittance`,
      isShow: isRemitEnabled,
    },
    {
      label: "News",
      link: `/${username ? `${username}/` : ""}news`,
      isShow: isNewsEnabled,
    },
    {
      label: "Video Tours",
      link: `/${username ? `${username}/` : ""}destination-guides/`,
      isShow: isVideoToursEnabled,
    },
    {
      label: "Pay Safely",
      link: `/${username ? `${username}/` : ""}pay`,
      isShow: isPaySafelyEnabled,
    },
    {
      id: "know-more",
      label: "Know Us",
      link: "know us",
      dropdown: true,
      clickHandle: true,
      clickItem: knowUsItem,
      isShow: true,
    },
  ];
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const location = useLocation();
  const history = useHistory();

  const [toggleMenu, setToggleMenu] = useState(false);
  const [componentType, setComponentType] = useState(null);
  const [componentImg, setComponentImg] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [clickItem, setClickItem] = useState([]);
  const [isLoginMenu, setIsLoginMenu] = useState(false);
  const [contentArr, setContentArr] = useState(contentArrInitial);

  const loginItem = [
    {
      label: `My Bookings`,
      id: "bookings",
      link: `/${username ? `${username}/` : ""}en/my_bookings`,
    },
    { label: "LOGOUT", imgLink: logout, id: "logout" },
  ];

  useEffect(() => {
    if (!navbarTemplateType) return;
    setComponentType(navbarTemplateType.card_type);
    setComponentImg(navbarTemplateType.background_image);
  }, [navbarTemplateType]);

  useEffect(() => {
    if (!domainName) return;
    getAdditionalPages(articles);
  }, [domainName]);

  useEffect(() => {
    let newContentArr = contentArr.map((item) => {
      if (item.id && item.id == "know-more")
        return {
          id: "know-more",
          label: "Know Us",
          link: "know us",
          dropdown: true,
          clickHandle: true,
          clickItem: knowUsItem,
        };
      else return item;
    });
    setContentArr(newContentArr);
  }, [knowUsItem]);

  useEffect(() => {
    if (!websiteModules || isEmptyObject(websiteModules)) return;
    let newContentArr = [];
    contentArrInitial.forEach((navbarItem) => {
      const { isShow = false } = navbarItem;
      if (isShow) {
        newContentArr.push(navbarItem);
      }
    });
    setContentArr(newContentArr);
  }, [websiteModules, knowUsItem]);

  const getAdditionalPages = async (results) => {
    addToKnowUsItem([...results, ...SERVICES_ADDITIONAL_PAGE_DATA]);
  };

  const onNavIconClick = () => {
    setToggleMenu(!toggleMenu);
  };

  const handleCovidMenuClick = (
    event,
    clickItemParam = [],
    islogin = false
  ) => {
    setIsLoginMenu(islogin);
    if (clickItemParam.length > 0) setClickItem(clickItemParam);
    if (anchorEl == null) setAnchorEl(event.currentTarget);
    else handleCovidMenuClose();
  };

  const handleCovidMenuClose = () => {
    setAnchorEl(null);
    setClickItem([]);
  };

  const handleCovidMenuItemClick = (event, index, item) => {
    if (isLoggedIn && item.id === "logout") handleLogoutClick(item);
    if (item.reloadLink) window.location = item.link;
    else history.push(item.link);
  };

  const handleLogoutClick = () => {
    LocalStorage.deleteUser();
    history.push(`/${username ? `${username}/` : ""}`);
    window.location.reload();
  };

  const handleListItemClick = (element) => {
    element && history.push(element.link);
     window.location.reload();
  };

  useEffect(() => {
    handleCovidMenuClose();
    setToggleMenu(false);
  }, [location.pathname]);

  const getLogoUrl = (url = "") => {
    let replaceStr = "https://s3.ap-south-1.amazonaws.com/com.travclan.b2b2c/";
    if (url.includes("cms/media")) {
      url = decodeURIComponent(url);
      url = url.slice(replaceStr.length + "https:".length);
      url = `https:/${url}`;
    }
    return thumborImageUrl(url, 0, 100);
  };

  const LoginSignInModal = (props) => {
    return <LoginSignUpModal {...props} />;
  };

  let widgetList = [
    {
      id: "loginModal",
      component: LoginSignInModal,
      description: "Login/Sign up modal",
      propsList: ["onClose"],
    },
  ];

  if (isV2Template)
    return (
      <TripkartTemplates
        templateName={template_name}
        websiteData={websiteData}
        onlyComponentType="navbar"
        type="otherPage"
        widgetList={widgetList}
      />
    );

  const ComponentName = componentType ? compnentsMap[componentType] : null;

  if (!ComponentName) return null;

  const MyComponentWithBackground = withBackground(
    ComponentName,
    navbarTemplateType
  );

  console.log(contentArr, "contentArr asdkasdkkhh  jkhsadjkhdjksahkjhjkashdk");

  return (
    <>
      <MyComponentWithBackground
        nonTransparentNav={nonTransparentNav}
        logo_url={logo_url}
        isMobile={isMobile}
        toggleMenu={toggleMenu}
        getLogoUrl={getLogoUrl}
        contentArr={contentArr}
        username={username}
        onNavIconClick={onNavIconClick}
        memberProfile={memberProfile}
        setToggleMenu={setToggleMenu}
        componentImg={thumborImageUrl(componentImg, 1000, 0)}
        handleCovidMenuClick={handleCovidMenuClick}
        handleCovidMenuClose={handleCovidMenuClose}
        anchorEl={anchorEl}
        clickItem={clickItem}
        isLoginMenu={isLoginMenu}
        handleCovidMenuItemClick={handleCovidMenuItemClick}
        handleListItemClick={handleListItemClick}
        websiteData={websiteData}
        widgetList={widgetList}
        loginItem={loginItem}
        handleLogoutClick={handleLogoutClick}
      />

      {toggleMenu && (
        <MobileNavDrawer
          mobileNavBarOpen={toggleMenu}
          isMobile={isMobile}
          logoutClick={handleLogoutClick}
          setToggleMenu={setToggleMenu}
          contentArr={isLoginMenu ? [] : contentArr}
          username={username}
          isLoginMenu={isLoginMenu}
          handleListItemClick={handleListItemClick}
          componentType={componentType}
          memberProfile={memberProfile}
        />
      )}
    </>
  );
};
